import React from 'react';
import { Box, FiservCardInterface } from '@common-fe/common-fe';

import { CardItemActions } from '@/modules/transaction/components/Cards/components/CardItemActions';

// import { StyledActionsCarousel } from '../CardCarousel/CardCarousel.styles';

interface Props {
  cards: FiservCardInterface[];
  isDarkMode?: boolean;
  selectedItemIndex: number;
}

interface CardActionProps {
  card: FiservCardInterface;
  selectedItemIndex: number;
  index: number;
  isDarkMode?: boolean;
}
const CardAction: React.FC<CardActionProps> = ({ card, index, selectedItemIndex, isDarkMode }) => {
  if (isDarkMode) {
    return (
      <Box justify="center" data-testid={`CardActionsCarousel-item-${card.id}`}>
        {selectedItemIndex === index && <CardItemActions card={card} isDarkMode />}
      </Box>
    );
  }
  return (
    <Box justify="center" fill width={{ max: '500px' }}>
      <Box>
        {selectedItemIndex === index && (
          <Box data-testid={`CardActionsCarousel-item-${card.id}`}>
            <CardItemActions card={card} isDarkMode={isDarkMode} />
          </Box>
        )}
      </Box>
    </Box>
  );
};

export const CardActionsCarousel: React.FC<Props> = ({ cards, selectedItemIndex, isDarkMode }) => (
  <Box fill pad={isDarkMode ? undefined : 'spacing12'}>
    {cards.map((card, index) => (
      <CardAction
        card={card}
        key={card.id}
        index={index}
        selectedItemIndex={selectedItemIndex}
        isDarkMode={isDarkMode}
      />
    ))}
  </Box>
);
